
import { VisionScenario, VisionCriteria, VisionWrapper, Vision } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_HTTP_METHOD, WIZ_COMMAND_METHOD, WIZ_COMMAND_RESPONSE_TYPE, WIZ_COMMAND_STATE } from '@wizeoo/akm-core-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { BusinessUnitVO } from '../../vo/core/business-unit.vo';
import { ViewData } from '../../model/view.data';
import { UserApplicationVO } from '../../vo/user/user-app.vo';
import { StaticFeatureEnum } from '../../manager/permission/permissions.types';
import { VISION_PROPERTY } from '../../model/enums';
import { VisionVO } from '@wizeoo/akm-compute-lib';

/** chargement de l'ensemble des visions de la BU, sans les steps */
export class MyAppsCommand extends WizCommand<VisionWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  /**
   * Le résultat du chargement des visions seulement en mode all
   */
  visions: VisionVO[];

  /**
   * Recherche de toutes les visions pour le domaine du user. On va seulement charger le header
   */
  findAllVisions(pCallback?: (cmd: MyAppsCommand) => void): MyAppsCommand {
    const wrapper: VisionWrapper = new VisionWrapper();
    wrapper.scenario = new VisionScenario();
    wrapper.scenario.manageKeys = true;
    wrapper.scenario.manageSteps = true;
    wrapper.scenario.manageMeasures = true;
    wrapper.criteria = new VisionCriteria();
    wrapper.criteria.domain = this.model.domainCode; // currentDomainCode;
    // const doms: DomainVO[] = this.model.connectedUser.allDomains;
    // wrapper.criteria.domainList = doms.map((item) => item.code);
    wrapper.method = WIZ_COMMAND_METHOD.FIND;

    super.configureRemote(
      ExternalAPI.VISION_API,
      wrapper,
      pCallback,
      WIZ_COMMAND_HTTP_METHOD.POST,
      WIZ_COMMAND_RESPONSE_TYPE.JSON
    );

    return this;
  }

  wizResult() {
    super.wizResult();
    if (this.state === WIZ_COMMAND_STATE.SUCCESS && !!this.result) {
      // console.log('vision loaded');
      const vos: VisionVO[] = [];
      this.result.entities.forEach((v: Vision) => {
        if(!v) {
          console.log('Bad vision', v);
        } else {
          vos.push(this.model.visionEngine.newVisionVO(v));
        }
      })
      
      // const vos = this.result.entities.map((vision) => this.model.visionEngine.newVisionVO(vision));

      const bus = this.model.businessUnitList;   
      const visionAndBus: VisionVO[] = []; // visions + accès BU.*

      bus.forEach((bu: BusinessUnitVO) => { // ajout des accès BUs
        const vis: Vision = new Vision();
        vis.domain = bu.domain;
        vis.businessUnitCode = bu.businessUnitCode;
        vis.code = ViewData.wildcardDomain;
        const visionVO: VisionVO = this.model.visionEngine.newVisionVO(vis);
        this.model.visionEngine.setVisionProperties(visionVO, VISION_PROPERTY.ISCONFIGAPP, true);

        const uappVO: UserApplicationVO = new UserApplicationVO(this.model);
        uappVO.domain = vis.domain;
        uappVO.businessUnitCode = vis.businessUnitCode;
        uappVO.visionCode = vis.code;
        if (this.model.permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, uappVO)) {
          visionAndBus.push(visionVO);
        } 
      })

      if (!!vos) {
        vos.forEach((vis: VisionVO) => {
          const uappVO: UserApplicationVO = new UserApplicationVO(this.model);
          uappVO.domain = vis.domain;
          uappVO.businessUnitCode = vis.businessUnitCode;
          uappVO.visionCode = vis.code;
          if (this.model.permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, uappVO)) {
            // console.log('visionAndBU', vis);
            visionAndBus.push(vis);
          }
        });
      }

      this.visions = visionAndBus;
      this.model.visionEngine.feedVisions(visionAndBus, true);
    }
  }
}
